import React, { Component } from 'react';
import { connect } from 'react-redux';
import { storeList } from '../../actions';
import { bindActionCreators } from 'redux';


class Tshirts extends Component {

  componentDidMount() {
    this.props.storeList();
  }

  renderList = (storeItems) => {
    if(storeItems) {
      return storeItems.map((items) => {
        return (
          <li key={items.id} className={`col item-${items.id}`}>
            <a href={items.url} target="_blank">
               <img src={items.img} alt={items.title} />
             </a>
             <h3>{items.title}</h3>
             <p>{items.desc}</p>
             <div className="button-wrapper">
               <a href={items.url} target="_blank" className="button">
                 <span className="buy">Buy Now</span><span className="price">${items.price}</span>
               </a>
             </div>
          </li>
        );
      });
    }
  }

  render() {
    return (
      <div id="tshirts" className="container">
        <div className="content">
          <div className="mini-content">
            <h2>T-Shirts With A Purpose</h2>
            <p className="max-width-85">Our T-shirt line is the perfect gift for kids. It's cute and stylish, it promotes a positive message and we donate 10% of our proceeds to anti-bully organizations nationwide. </p>
          </div>
          <ul className="store new-collection">{this.renderList(this.props.storeItems)}</ul>
        </div>
      </div>
    )
  }
}



function mapStateToProps(state) {
  return {
    storeItems: state.storeItems
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ storeList }, dispatch)
}

export default connect(mapStateToProps,  mapDispatchToProps)(Tshirts);



// WEBPACK FOOTER //
// ./src/container/home/Tshirts.js